module.exports = __webpack_public_path__ + "img/pr-1.96db6696.png";